import { type GID } from "@unlikelystudio/commerce-connector"

import { CARD_PRODUCT_GETTER_PARAMS } from "~/lib/shopify/constants/query-parameters"
import { getSfProducts } from "~/lib/shopify/queries/get-sf-products"
import { fromGidsToQueryIds } from "~/lib/shopify/utils/id"

export async function getShopifyProductsByIds(
  ids: (string | GID)[],
  params: Pick<Parameters<typeof getSfProducts>[0], "sortKey" | "locale">,
  options?: Parameters<typeof getSfProducts>[1]
) {
  return getSfProducts(
    {
      first: ids.length,
      query: fromGidsToQueryIds(ids),
      locale: params.locale,
      sortKey: params.sortKey,
      ...CARD_PRODUCT_GETTER_PARAMS,
      // Need this for cross sell product cards
      variantsFirst: 50
    },
    options
  )
}
